import React, { useRef } from "react";
import Barcode from "react-barcode";
import "./BarcodeModal.css";
import { currency } from "../../App";

const BarcodeModal = ({ product, onClose }) => {
  const printRef = useRef();

  const offerPrice = (
    product.old_price - (product.old_price * product.new_price) / 100
  ).toFixed(2);

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>Barcode - ${product.name}</title>
          <style>
            /* Exact label size for TVS LP 46 Lite (50mm x 25mm), edge-to-edge */
            @page { size: 50mm 25mm; margin: 0; }
            * { box-sizing: border-box; }
            html, body { margin: 0; padding: 0; background: #fff; }
            body { font-family: Arial, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            .barcode-print-wrapper {
              width: 50mm;
              height: 25mm;
              padding: 1mm 1.5mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center;
              overflow: hidden;
            }
            .barcode-print-name { font-size: 8pt; font-weight: bold; margin: 0; color: #000; line-height: 1.1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; }
            .barcode-print-wrapper svg { height: 11mm; width: auto; max-width: 47mm; margin: 0.5mm 0; }
            .barcode-print-price { font-size: 9pt; font-weight: bold; color: #000; margin: 0; line-height: 1.1; }
            .barcode-print-id { font-size: 6pt; color: #000; margin: 0; line-height: 1.1; }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  return (
    <div className="barcode-overlay" onClick={onClose}>
      <div className="barcode-modal" onClick={(e) => e.stopPropagation()}>
        <button className="barcode-close-btn" onClick={onClose}>×</button>
        <h3 className="barcode-modal-title">Product Barcode</h3>

        <div className="barcode-print-wrapper" ref={printRef}>
          <div className="barcode-print-name">{product.name}</div>
          <Barcode
            value={product.unique_id}
            width={1.8}
            height={70}
            fontSize={13}
            displayValue={true}
            background="#ffffff"
            lineColor="#000000"
          />
          <div className="barcode-print-price">
            Price: {currency}{offerPrice}
          </div>
          <div className="barcode-print-id">ID: {product.unique_id}</div>
        </div>

        <button className="barcode-print-btn" onClick={handlePrint}>
          Print Barcode
        </button>
      </div>
    </div>
  );
};

export default BarcodeModal;
